import { useEffect, useRef, useState } from 'react';
import { Search, X } from 'lucide-react';
import { cn } from '../../utils/cn';

export default function SearchBar() {
  const [open, setOpen] = useState(false);
  const [value, setValue] = useState('');
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (open) inputRef.current?.focus();
  }, [open]);

  if (!open) {
    return (
      <button
        type="button"
        aria-label="Open search"
        onClick={() => setOpen(true)}
        className="flex h-8 w-8 items-center justify-center rounded-lg text-content-muted hover:bg-surface-card-hover hover:text-content-primary transition-colors"
      >
        <Search size={18} />
      </button>
    );
  }

  return (
    <div
      className={cn(
        'flex items-center gap-2 rounded-lg border border-primary bg-surface-card px-3 py-1.5 transition-colors',
        'w-72 max-w-full'
      )}
    >
      <Search size={16} className="text-content-muted flex-shrink-0" />
      <input
        ref={inputRef}
        type="text"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        placeholder="Search..."
        onKeyDown={(e) => {
          if (e.key === 'Escape') {
            setOpen(false);
            setValue('');
          }
        }}
        className="w-full bg-transparent text-sm text-content-primary placeholder:text-content-muted outline-none"
      />
      <button
        type="button"
        aria-label="Close search"
        onClick={() => {
          setOpen(false);
          setValue('');
        }}
        className="flex h-5 w-5 items-center justify-center rounded text-content-muted hover:bg-surface-card-hover hover:text-content-primary"
      >
        <X size={14} />
      </button>
    </div>
  );
}
